import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useImages } from '@/components/admin/Images/MergeHistoryModal/MergeHistoryModal.utils';
import Text from '@/components/ui/Text';
import { IImage } from '@/components/admin/Images/interfaces';

interface SelectAllButtonProps {
  image: IImage;
  revertedImageIds: number[];
}

export const SelectAllButton = ({ image, revertedImageIds }: SelectAllButtonProps) => {
  const { data: images } = useImages({ image });
  const { setValue, watch } = useFormContext();
  const currentIds = watch('imageIds');
  const canRevert = revertedImageIds.length < images.length;

  const handleChange = () => {
    if (currentIds.length === images.length) {
      setValue('imageIds', []);
    } else {
      const nonRevertedIds = images.filter(im => !revertedImageIds.includes(im.id)).map(im => im.id.toString());
      setValue('imageIds', nonRevertedIds);
    }
  };

  if (images.length === 0) return null;

  return (
    <label className="tw-cursor-pointer tw-pl-3 tw-pb-2 tw-flex tw-items-center tw-gap-1">
      <input
        checked={images.length === currentIds.length}
        className="tw-m-0 tw-cursor-pointer"
        disabled={!canRevert}
        type="checkbox"
        onChange={handleChange}
      />
      <Text className="-tw-mt-px" size="sm">
        Select All
      </Text>
    </label>
  );
};
